// source: command_proto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var command_public_proto_pb = require('./command_public_proto_pb.js');
goog.object.extend(proto, command_public_proto_pb);
var primitive_proto_pb = require('./primitive_proto_pb.js');
goog.object.extend(proto, primitive_proto_pb);
var user_proto_pb = require('./user_proto_pb.js');
goog.object.extend(proto, user_proto_pb);
var meshfile_proto_pb = require('./meshfile_proto_pb.js');
goog.object.extend(proto, meshfile_proto_pb);
goog.exportSymbol('proto.AltitudeRequestCommand', null, global);
goog.exportSymbol('proto.AltitudeUpdateCommand', null, global);
goog.exportSymbol('proto.CellularStatusCommand', null, global);
goog.exportSymbol('proto.CellularStatusCommand.ConnectionStatus', null, global);
goog.exportSymbol('proto.DataChunkCommand', null, global);
goog.exportSymbol('proto.DataChunkCommand.DataChunkType', null, global);
goog.exportSymbol('proto.DeviceForwardConfirmCommand', null, global);
goog.exportSymbol('proto.DevicePowerOnoffCommand', null, global);
goog.exportSymbol('proto.DevicePowerOnoffCommand.DevicePowerOnoffType', null, global);
goog.exportSymbol('proto.EligibleBackhaul', null, global);
goog.exportSymbol('proto.FactoryCommand', null, global);
goog.exportSymbol('proto.FactoryCommand.FactoryCommandType', null, global);
goog.exportSymbol('proto.FlashLogFileCommand', null, global);
goog.exportSymbol('proto.FlashLogFileCommand.FlashLogFileCommandType', null, global);
goog.exportSymbol('proto.GpsRequestCommand', null, global);
goog.exportSymbol('proto.MeshCmdDataMeshNetworkUpdates', null, global);
goog.exportSymbol('proto.MeshCmdDataSettings', null, global);
goog.exportSymbol('proto.MeshCmdGetCommand', null, global);
goog.exportSymbol('proto.MeshCmdReportCommand', null, global);
goog.exportSymbol('proto.MeshCmdReportCommand.DataCase', null, global);
goog.exportSymbol('proto.MeshCmdReportCommand.EmptyData', null, global);
goog.exportSymbol('proto.MeshCmdSetCommand', null, global);
goog.exportSymbol('proto.MeshFileBlockPartCommand', null, global);
goog.exportSymbol('proto.MeshFileBlockTxDoneCommand', null, global);
goog.exportSymbol('proto.MeshFileInitRequestCommand', null, global);
goog.exportSymbol('proto.MeshFileInitResponseCommand', null, global);
goog.exportSymbol('proto.MeshFileInitiatedAckCommand', null, global);
goog.exportSymbol('proto.MeshFileInitiatedCommand', null, global);
goog.exportSymbol('proto.MeshNeighborUpdate', null, global);
goog.exportSymbol('proto.MeshNetworkUpdate', null, global);
goog.exportSymbol('proto.ParcelMap', null, global);
goog.exportSymbol('proto.PeripheralCommand', null, global);
goog.exportSymbol('proto.PeripheralCommand.ConnectionState', null, global);
goog.exportSymbol('proto.PeripheralCommand.Type', null, global);
goog.exportSymbol('proto.QueueSyncCompleteCommand', null, global);
goog.exportSymbol('proto.RegistrationCommand', null, global);
goog.exportSymbol('proto.RegistrationCommand.ApplicationType', null, global);
goog.exportSymbol('proto.SerialNumberCommand', null, global);
goog.exportSymbol('proto.SerialNumberRequestCommand', null, global);
goog.exportSymbol('proto.SettingsCommand', null, global);
goog.exportSymbol('proto.SettingsCommand.ConnectionMode', null, global);
goog.exportSymbol('proto.SettingsCommand.LogType', null, global);
goog.exportSymbol('proto.SettingsCommand.PowerMode', null, global);
goog.exportSymbol('proto.SettingsCommand.RadioFrequenciesHz', null, global);
goog.exportSymbol('proto.ShortMeshNetworkUpdateEntry', null, global);
goog.exportSymbol('proto.TrackingCommand', null, global);
goog.exportSymbol('proto.UserProfile', null, global);
goog.exportSymbol('proto.UserProfile.UserProfileType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ParcelMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ParcelMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ParcelMap.displayName = 'proto.ParcelMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SettingsCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SettingsCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SettingsCommand.displayName = 'proto.SettingsCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TrackingCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.TrackingCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.TrackingCommand.displayName = 'proto.TrackingCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GpsRequestCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.GpsRequestCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GpsRequestCommand.displayName = 'proto.GpsRequestCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.QueueSyncCompleteCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.QueueSyncCompleteCommand.repeatedFields_, null);
};
goog.inherits(proto.QueueSyncCompleteCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.QueueSyncCompleteCommand.displayName = 'proto.QueueSyncCompleteCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.RegistrationCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.RegistrationCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.RegistrationCommand.displayName = 'proto.RegistrationCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UserProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UserProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.UserProfile.displayName = 'proto.UserProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AltitudeRequestCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.AltitudeRequestCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.AltitudeRequestCommand.displayName = 'proto.AltitudeRequestCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AltitudeUpdateCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.AltitudeUpdateCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.AltitudeUpdateCommand.displayName = 'proto.AltitudeUpdateCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SerialNumberRequestCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SerialNumberRequestCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SerialNumberRequestCommand.displayName = 'proto.SerialNumberRequestCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SerialNumberCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SerialNumberCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SerialNumberCommand.displayName = 'proto.SerialNumberCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PeripheralCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PeripheralCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PeripheralCommand.displayName = 'proto.PeripheralCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.EligibleBackhaul = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.EligibleBackhaul, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.EligibleBackhaul.displayName = 'proto.EligibleBackhaul';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MeshNetworkUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MeshNetworkUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MeshNetworkUpdate.displayName = 'proto.MeshNetworkUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MeshNeighborUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MeshNeighborUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MeshNeighborUpdate.displayName = 'proto.MeshNeighborUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CellularStatusCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CellularStatusCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CellularStatusCommand.displayName = 'proto.CellularStatusCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DataChunkCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DataChunkCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DataChunkCommand.displayName = 'proto.DataChunkCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.FlashLogFileCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.FlashLogFileCommand.repeatedFields_, null);
};
goog.inherits(proto.FlashLogFileCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.FlashLogFileCommand.displayName = 'proto.FlashLogFileCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MeshFileInitRequestCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MeshFileInitRequestCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MeshFileInitRequestCommand.displayName = 'proto.MeshFileInitRequestCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MeshFileInitResponseCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.MeshFileInitResponseCommand.repeatedFields_, null);
};
goog.inherits(proto.MeshFileInitResponseCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MeshFileInitResponseCommand.displayName = 'proto.MeshFileInitResponseCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MeshFileBlockPartCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MeshFileBlockPartCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MeshFileBlockPartCommand.displayName = 'proto.MeshFileBlockPartCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MeshFileBlockTxDoneCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.MeshFileBlockTxDoneCommand.repeatedFields_, null);
};
goog.inherits(proto.MeshFileBlockTxDoneCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MeshFileBlockTxDoneCommand.displayName = 'proto.MeshFileBlockTxDoneCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MeshFileInitiatedCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MeshFileInitiatedCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MeshFileInitiatedCommand.displayName = 'proto.MeshFileInitiatedCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MeshFileInitiatedAckCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MeshFileInitiatedAckCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MeshFileInitiatedAckCommand.displayName = 'proto.MeshFileInitiatedAckCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MeshCmdDataSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MeshCmdDataSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MeshCmdDataSettings.displayName = 'proto.MeshCmdDataSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ShortMeshNetworkUpdateEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ShortMeshNetworkUpdateEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ShortMeshNetworkUpdateEntry.displayName = 'proto.ShortMeshNetworkUpdateEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MeshCmdDataMeshNetworkUpdates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.MeshCmdDataMeshNetworkUpdates.repeatedFields_, null);
};
goog.inherits(proto.MeshCmdDataMeshNetworkUpdates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MeshCmdDataMeshNetworkUpdates.displayName = 'proto.MeshCmdDataMeshNetworkUpdates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MeshCmdGetCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MeshCmdGetCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MeshCmdGetCommand.displayName = 'proto.MeshCmdGetCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MeshCmdSetCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MeshCmdSetCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MeshCmdSetCommand.displayName = 'proto.MeshCmdSetCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MeshCmdReportCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.MeshCmdReportCommand.oneofGroups_);
};
goog.inherits(proto.MeshCmdReportCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MeshCmdReportCommand.displayName = 'proto.MeshCmdReportCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MeshCmdReportCommand.EmptyData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MeshCmdReportCommand.EmptyData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MeshCmdReportCommand.EmptyData.displayName = 'proto.MeshCmdReportCommand.EmptyData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeviceForwardConfirmCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeviceForwardConfirmCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeviceForwardConfirmCommand.displayName = 'proto.DeviceForwardConfirmCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.FactoryCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.FactoryCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.FactoryCommand.displayName = 'proto.FactoryCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DevicePowerOnoffCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DevicePowerOnoffCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DevicePowerOnoffCommand.displayName = 'proto.DevicePowerOnoffCommand';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ParcelMap.prototype.toObject = function(opt_includeInstance) {
  return proto.ParcelMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ParcelMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ParcelMap.toObject = function(includeInstance, msg) {
  var f, obj = {
parcelsMap: (f = msg.getParcelsMap()) ? f.toObject(includeInstance, proto.Parcel.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ParcelMap}
 */
proto.ParcelMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ParcelMap;
  return proto.ParcelMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ParcelMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ParcelMap}
 */
proto.ParcelMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getParcelsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readMessage, proto.Parcel.deserializeBinaryFromReader, 0, new proto.Parcel());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ParcelMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ParcelMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ParcelMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ParcelMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParcelsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeMessage, proto.Parcel.serializeBinaryToWriter);
  }
};


/**
 * map<uint32, Parcel> parcels = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.Parcel>}
 */
proto.ParcelMap.prototype.getParcelsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.Parcel>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.Parcel));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.ParcelMap} returns this
 */
proto.ParcelMap.prototype.clearParcelsMap = function() {
  this.getParcelsMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SettingsCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.SettingsCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SettingsCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SettingsCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
trackinginterval: jspb.Message.getFieldWithDefault(msg, 1, 0),
gpsinterval: jspb.Message.getFieldWithDefault(msg, 2, 0),
gpsinitialfix: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
encryptionenabled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
nosleep: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
includeAltitude: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
batteryReporting: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
automaticTracking: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
connectionMode: jspb.Message.getFieldWithDefault(msg, 9, 0),
logType: jspb.Message.getFieldWithDefault(msg, 10, 0),
logTypeBitmask: jspb.Message.getFieldWithDefault(msg, 11, 0),
sentTimestamp: jspb.Message.getFieldWithDefault(msg, 12, 0),
satDisabled: jspb.Message.getFieldWithDefault(msg, 13, 0),
ledDisabled: jspb.Message.getFieldWithDefault(msg, 14, 0),
radioMode: jspb.Message.getFieldWithDefault(msg, 15, 0),
includeSpeedAndCourse: jspb.Message.getFieldWithDefault(msg, 16, 0),
button1: jspb.Message.getFieldWithDefault(msg, 17, 0),
lowSpeedFrequencyHz: jspb.Message.getFieldWithDefault(msg, 18, 0),
highSpeedFrequencyHz: jspb.Message.getFieldWithDefault(msg, 19, 0),
radioPowerMode: jspb.Message.getFieldWithDefault(msg, 20, 0),
swapRadios: jspb.Message.getFieldWithDefault(msg, 21, 0),
sentByUserId: jspb.Message.getFieldWithDefault(msg, 22, 0),
backhaulEnabled: jspb.Message.getFieldWithDefault(msg, 23, 0),
hapticsDisabled: jspb.Message.getFieldWithDefault(msg, 24, 0),
lowDataModeEnabled: jspb.Message.getFieldWithDefault(msg, 25, 0),
bleAdvDeviceNameDisabled: jspb.Message.getFieldWithDefault(msg, 26, 0),
locationBackhaulRate: jspb.Message.getFieldWithDefault(msg, 27, 0),
meshVersionToDeploy: jspb.Message.getFieldWithDefault(msg, 28, 0),
lowSpeedDataRateParameters: (f = msg.getLowSpeedDataRateParameters()) && command_public_proto_pb.RadioDataRateParameters.toObject(includeInstance, f),
highSpeedDataRateParameters: (f = msg.getHighSpeedDataRateParameters()) && command_public_proto_pb.RadioDataRateParameters.toObject(includeInstance, f),
radioRegion: jspb.Message.getFieldWithDefault(msg, 31, 0),
appliedTime: jspb.Message.getFieldWithDefault(msg, 32, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SettingsCommand}
 */
proto.SettingsCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SettingsCommand;
  return proto.SettingsCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SettingsCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SettingsCommand}
 */
proto.SettingsCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTrackinginterval(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setGpsinterval(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGpsinitialfix(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEncryptionenabled(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNosleep(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeAltitude(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBatteryReporting(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutomaticTracking(value);
      break;
    case 9:
      var value = /** @type {!proto.SettingsCommand.ConnectionMode} */ (reader.readEnum());
      msg.setConnectionMode(value);
      break;
    case 10:
      var value = /** @type {!proto.SettingsCommand.LogType} */ (reader.readEnum());
      msg.setLogType(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLogTypeBitmask(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSentTimestamp(value);
      break;
    case 13:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setSatDisabled(value);
      break;
    case 14:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setLedDisabled(value);
      break;
    case 15:
      var value = /** @type {!proto.RadioMode} */ (reader.readEnum());
      msg.setRadioMode(value);
      break;
    case 16:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setIncludeSpeedAndCourse(value);
      break;
    case 17:
      var value = /** @type {!proto.ButtonFunction} */ (reader.readEnum());
      msg.setButton1(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLowSpeedFrequencyHz(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHighSpeedFrequencyHz(value);
      break;
    case 20:
      var value = /** @type {!proto.SettingsCommand.PowerMode} */ (reader.readEnum());
      msg.setRadioPowerMode(value);
      break;
    case 21:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setSwapRadios(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSentByUserId(value);
      break;
    case 23:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setBackhaulEnabled(value);
      break;
    case 24:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setHapticsDisabled(value);
      break;
    case 25:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setLowDataModeEnabled(value);
      break;
    case 26:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setBleAdvDeviceNameDisabled(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLocationBackhaulRate(value);
      break;
    case 28:
      var value = /** @type {!proto.MeshVersion} */ (reader.readEnum());
      msg.setMeshVersionToDeploy(value);
      break;
    case 29:
      var value = new command_public_proto_pb.RadioDataRateParameters;
      reader.readMessage(value,command_public_proto_pb.RadioDataRateParameters.deserializeBinaryFromReader);
      msg.setLowSpeedDataRateParameters(value);
      break;
    case 30:
      var value = new command_public_proto_pb.RadioDataRateParameters;
      reader.readMessage(value,command_public_proto_pb.RadioDataRateParameters.deserializeBinaryFromReader);
      msg.setHighSpeedDataRateParameters(value);
      break;
    case 31:
      var value = /** @type {!proto.RadioRegion} */ (reader.readEnum());
      msg.setRadioRegion(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setAppliedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SettingsCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SettingsCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SettingsCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SettingsCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrackinginterval();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getGpsinterval();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getGpsinitialfix();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getEncryptionenabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getNosleep();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getIncludeAltitude();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getBatteryReporting();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getAutomaticTracking();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getConnectionMode();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getLogType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getLogTypeBitmask();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getSentTimestamp();
  if (f !== 0) {
    writer.writeFixed32(
      12,
      f
    );
  }
  f = message.getSatDisabled();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getLedDisabled();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getRadioMode();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getIncludeSpeedAndCourse();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getButton1();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getLowSpeedFrequencyHz();
  if (f !== 0) {
    writer.writeUint32(
      18,
      f
    );
  }
  f = message.getHighSpeedFrequencyHz();
  if (f !== 0) {
    writer.writeUint32(
      19,
      f
    );
  }
  f = message.getRadioPowerMode();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getSwapRadios();
  if (f !== 0.0) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = message.getSentByUserId();
  if (f !== 0) {
    writer.writeUint64(
      22,
      f
    );
  }
  f = message.getBackhaulEnabled();
  if (f !== 0.0) {
    writer.writeEnum(
      23,
      f
    );
  }
  f = message.getHapticsDisabled();
  if (f !== 0.0) {
    writer.writeEnum(
      24,
      f
    );
  }
  f = message.getLowDataModeEnabled();
  if (f !== 0.0) {
    writer.writeEnum(
      25,
      f
    );
  }
  f = message.getBleAdvDeviceNameDisabled();
  if (f !== 0.0) {
    writer.writeEnum(
      26,
      f
    );
  }
  f = message.getLocationBackhaulRate();
  if (f !== 0) {
    writer.writeUint32(
      27,
      f
    );
  }
  f = message.getMeshVersionToDeploy();
  if (f !== 0.0) {
    writer.writeEnum(
      28,
      f
    );
  }
  f = message.getLowSpeedDataRateParameters();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      command_public_proto_pb.RadioDataRateParameters.serializeBinaryToWriter
    );
  }
  f = message.getHighSpeedDataRateParameters();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      command_public_proto_pb.RadioDataRateParameters.serializeBinaryToWriter
    );
  }
  f = message.getRadioRegion();
  if (f !== 0.0) {
    writer.writeEnum(
      31,
      f
    );
  }
  f = message.getAppliedTime();
  if (f !== 0) {
    writer.writeFixed32(
      32,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.SettingsCommand.ConnectionMode = {
  BLUETOOTH: 0,
  LINEIN: 1
};

/**
 * @enum {number}
 */
proto.SettingsCommand.LogType = {
  NONE: 0,
  BLUETOOTHLOG: 1,
  FLASHLOG: 2
};

/**
 * @enum {number}
 */
proto.SettingsCommand.PowerMode = {
  POWERMODELOW: 0,
  POWERMODEMEDIUM: 1,
  POWERMODEHIGH: 2
};

/**
 * @enum {number}
 */
proto.SettingsCommand.RadioFrequenciesHz = {
  INVALIDFREQUENCY: 0,
  R2MIN: 902000000,
  R2MAX: 928000000,
  EU47MIN: 865000000,
  EU47MAX: 868000000,
  EU54MIN: 869400000,
  EU54MAX: 869650000,
  EU56BMIN: 869700000,
  EU56BMAX: 870000000,
  DEFAULTLOWSPEED: 925750000,
  DEFAULTHIGHSPEED: 905250000,
  FREQ865500KHZ: 865500000,
  FREQ869432KHZ: 869432000,
  FREQ869525KHZ: 869525000,
  FREQ869587KHZ: 869587000,
  FREQ908500KHZ: 908500000,
  FREQ911750KHZ: 911750000,
  FREQ914000KHZ: 914000000,
  FREQ916000KHZ: 916000000,
  FREQ918000KHZ: 918000000,
  FREQ920000KHZ: 920000000,
  FREQ922000KHZ: 922000000,
  FREQ924000KHZ: 924000000,
  FREQ926000KHZ: 926000000,
  FREQ926500KHZ: 926500000,
  FREQ927250KHZ: 927250000
};

/**
 * optional uint32 trackingInterval = 1;
 * @return {number}
 */
proto.SettingsCommand.prototype.getTrackinginterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setTrackinginterval = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 gpsInterval = 2;
 * @return {number}
 */
proto.SettingsCommand.prototype.getGpsinterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setGpsinterval = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool gpsInitialFix = 3;
 * @return {boolean}
 */
proto.SettingsCommand.prototype.getGpsinitialfix = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setGpsinitialfix = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool encryptionEnabled = 4;
 * @return {boolean}
 */
proto.SettingsCommand.prototype.getEncryptionenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setEncryptionenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool noSleep = 5;
 * @return {boolean}
 */
proto.SettingsCommand.prototype.getNosleep = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setNosleep = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool include_altitude = 6;
 * @return {boolean}
 */
proto.SettingsCommand.prototype.getIncludeAltitude = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setIncludeAltitude = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool battery_reporting = 7;
 * @return {boolean}
 */
proto.SettingsCommand.prototype.getBatteryReporting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setBatteryReporting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool automatic_tracking = 8;
 * @return {boolean}
 */
proto.SettingsCommand.prototype.getAutomaticTracking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setAutomaticTracking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional ConnectionMode connection_mode = 9;
 * @return {!proto.SettingsCommand.ConnectionMode}
 */
proto.SettingsCommand.prototype.getConnectionMode = function() {
  return /** @type {!proto.SettingsCommand.ConnectionMode} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.SettingsCommand.ConnectionMode} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setConnectionMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional LogType log_type = 10;
 * @return {!proto.SettingsCommand.LogType}
 */
proto.SettingsCommand.prototype.getLogType = function() {
  return /** @type {!proto.SettingsCommand.LogType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.SettingsCommand.LogType} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setLogType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional uint32 log_type_bitmask = 11;
 * @return {number}
 */
proto.SettingsCommand.prototype.getLogTypeBitmask = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setLogTypeBitmask = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional fixed32 sent_timestamp = 12;
 * @return {number}
 */
proto.SettingsCommand.prototype.getSentTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setSentTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional OptionalBool sat_disabled = 13;
 * @return {!proto.OptionalBool}
 */
proto.SettingsCommand.prototype.getSatDisabled = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setSatDisabled = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional OptionalBool led_disabled = 14;
 * @return {!proto.OptionalBool}
 */
proto.SettingsCommand.prototype.getLedDisabled = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setLedDisabled = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional RadioMode radio_mode = 15;
 * @return {!proto.RadioMode}
 */
proto.SettingsCommand.prototype.getRadioMode = function() {
  return /** @type {!proto.RadioMode} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.RadioMode} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setRadioMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional OptionalBool include_speed_and_course = 16;
 * @return {!proto.OptionalBool}
 */
proto.SettingsCommand.prototype.getIncludeSpeedAndCourse = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setIncludeSpeedAndCourse = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional ButtonFunction button_1 = 17;
 * @return {!proto.ButtonFunction}
 */
proto.SettingsCommand.prototype.getButton1 = function() {
  return /** @type {!proto.ButtonFunction} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.ButtonFunction} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setButton1 = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional uint32 low_speed_frequency_hz = 18;
 * @return {number}
 */
proto.SettingsCommand.prototype.getLowSpeedFrequencyHz = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setLowSpeedFrequencyHz = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional uint32 high_speed_frequency_hz = 19;
 * @return {number}
 */
proto.SettingsCommand.prototype.getHighSpeedFrequencyHz = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setHighSpeedFrequencyHz = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional PowerMode radio_power_mode = 20;
 * @return {!proto.SettingsCommand.PowerMode}
 */
proto.SettingsCommand.prototype.getRadioPowerMode = function() {
  return /** @type {!proto.SettingsCommand.PowerMode} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.SettingsCommand.PowerMode} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setRadioPowerMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional OptionalBool swap_radios = 21;
 * @return {!proto.OptionalBool}
 */
proto.SettingsCommand.prototype.getSwapRadios = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setSwapRadios = function(value) {
  return jspb.Message.setProto3EnumField(this, 21, value);
};


/**
 * optional uint64 sent_by_user_id = 22;
 * @return {number}
 */
proto.SettingsCommand.prototype.getSentByUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setSentByUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional OptionalBool backhaul_enabled = 23;
 * @return {!proto.OptionalBool}
 */
proto.SettingsCommand.prototype.getBackhaulEnabled = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setBackhaulEnabled = function(value) {
  return jspb.Message.setProto3EnumField(this, 23, value);
};


/**
 * optional OptionalBool haptics_disabled = 24;
 * @return {!proto.OptionalBool}
 */
proto.SettingsCommand.prototype.getHapticsDisabled = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setHapticsDisabled = function(value) {
  return jspb.Message.setProto3EnumField(this, 24, value);
};


/**
 * optional OptionalBool low_data_mode_enabled = 25;
 * @return {!proto.OptionalBool}
 */
proto.SettingsCommand.prototype.getLowDataModeEnabled = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setLowDataModeEnabled = function(value) {
  return jspb.Message.setProto3EnumField(this, 25, value);
};


/**
 * optional OptionalBool ble_adv_device_name_disabled = 26;
 * @return {!proto.OptionalBool}
 */
proto.SettingsCommand.prototype.getBleAdvDeviceNameDisabled = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setBleAdvDeviceNameDisabled = function(value) {
  return jspb.Message.setProto3EnumField(this, 26, value);
};


/**
 * optional uint32 location_backhaul_rate = 27;
 * @return {number}
 */
proto.SettingsCommand.prototype.getLocationBackhaulRate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setLocationBackhaulRate = function(value) {
  return jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * optional MeshVersion mesh_version_to_deploy = 28;
 * @return {!proto.MeshVersion}
 */
proto.SettingsCommand.prototype.getMeshVersionToDeploy = function() {
  return /** @type {!proto.MeshVersion} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {!proto.MeshVersion} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setMeshVersionToDeploy = function(value) {
  return jspb.Message.setProto3EnumField(this, 28, value);
};


/**
 * optional RadioDataRateParameters low_speed_data_rate_parameters = 29;
 * @return {?proto.RadioDataRateParameters}
 */
proto.SettingsCommand.prototype.getLowSpeedDataRateParameters = function() {
  return /** @type{?proto.RadioDataRateParameters} */ (
    jspb.Message.getWrapperField(this, command_public_proto_pb.RadioDataRateParameters, 29));
};


/**
 * @param {?proto.RadioDataRateParameters|undefined} value
 * @return {!proto.SettingsCommand} returns this
*/
proto.SettingsCommand.prototype.setLowSpeedDataRateParameters = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.clearLowSpeedDataRateParameters = function() {
  return this.setLowSpeedDataRateParameters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SettingsCommand.prototype.hasLowSpeedDataRateParameters = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional RadioDataRateParameters high_speed_data_rate_parameters = 30;
 * @return {?proto.RadioDataRateParameters}
 */
proto.SettingsCommand.prototype.getHighSpeedDataRateParameters = function() {
  return /** @type{?proto.RadioDataRateParameters} */ (
    jspb.Message.getWrapperField(this, command_public_proto_pb.RadioDataRateParameters, 30));
};


/**
 * @param {?proto.RadioDataRateParameters|undefined} value
 * @return {!proto.SettingsCommand} returns this
*/
proto.SettingsCommand.prototype.setHighSpeedDataRateParameters = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.clearHighSpeedDataRateParameters = function() {
  return this.setHighSpeedDataRateParameters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SettingsCommand.prototype.hasHighSpeedDataRateParameters = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional RadioRegion radio_region = 31;
 * @return {!proto.RadioRegion}
 */
proto.SettingsCommand.prototype.getRadioRegion = function() {
  return /** @type {!proto.RadioRegion} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/**
 * @param {!proto.RadioRegion} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setRadioRegion = function(value) {
  return jspb.Message.setProto3EnumField(this, 31, value);
};


/**
 * optional fixed32 applied_time = 32;
 * @return {number}
 */
proto.SettingsCommand.prototype.getAppliedTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {number} value
 * @return {!proto.SettingsCommand} returns this
 */
proto.SettingsCommand.prototype.setAppliedTime = function(value) {
  return jspb.Message.setProto3IntField(this, 32, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.TrackingCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.TrackingCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TrackingCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
isEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
sentTimestamp: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TrackingCommand}
 */
proto.TrackingCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TrackingCommand;
  return proto.TrackingCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TrackingCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TrackingCommand}
 */
proto.TrackingCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEnabled(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSentTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TrackingCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.TrackingCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TrackingCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrackingCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getSentTimestamp();
  if (f !== 0) {
    writer.writeFixed32(
      2,
      f
    );
  }
};


/**
 * optional bool is_enabled = 1;
 * @return {boolean}
 */
proto.TrackingCommand.prototype.getIsEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.TrackingCommand} returns this
 */
proto.TrackingCommand.prototype.setIsEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional fixed32 sent_timestamp = 2;
 * @return {number}
 */
proto.TrackingCommand.prototype.getSentTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrackingCommand} returns this
 */
proto.TrackingCommand.prototype.setSentTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GpsRequestCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.GpsRequestCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GpsRequestCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GpsRequestCommand.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GpsRequestCommand}
 */
proto.GpsRequestCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GpsRequestCommand;
  return proto.GpsRequestCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GpsRequestCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GpsRequestCommand}
 */
proto.GpsRequestCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GpsRequestCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GpsRequestCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GpsRequestCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GpsRequestCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.QueueSyncCompleteCommand.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.QueueSyncCompleteCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.QueueSyncCompleteCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.QueueSyncCompleteCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.QueueSyncCompleteCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
parcelIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.QueueSyncCompleteCommand}
 */
proto.QueueSyncCompleteCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.QueueSyncCompleteCommand;
  return proto.QueueSyncCompleteCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.QueueSyncCompleteCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.QueueSyncCompleteCommand}
 */
proto.QueueSyncCompleteCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addParcelIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.QueueSyncCompleteCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.QueueSyncCompleteCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.QueueSyncCompleteCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.QueueSyncCompleteCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParcelIdsList();
  if (f.length > 0) {
    writer.writePackedUint32(
      2,
      f
    );
  }
};


/**
 * repeated uint32 parcel_ids = 2;
 * @return {!Array<number>}
 */
proto.QueueSyncCompleteCommand.prototype.getParcelIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.QueueSyncCompleteCommand} returns this
 */
proto.QueueSyncCompleteCommand.prototype.setParcelIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.QueueSyncCompleteCommand} returns this
 */
proto.QueueSyncCompleteCommand.prototype.addParcelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.QueueSyncCompleteCommand} returns this
 */
proto.QueueSyncCompleteCommand.prototype.clearParcelIdsList = function() {
  return this.setParcelIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.RegistrationCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.RegistrationCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.RegistrationCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.RegistrationCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
identityId: jspb.Message.getFieldWithDefault(msg, 1, 0),
userAccountId: jspb.Message.getFieldWithDefault(msg, 2, 0),
timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0),
timestampMillis: jspb.Message.getFieldWithDefault(msg, 4, 0),
profile: (f = msg.getProfile()) && proto.UserProfile.toObject(includeInstance, f),
applicationClientId: msg.getApplicationClientId_asB64(),
applicationType: jspb.Message.getFieldWithDefault(msg, 7, 0),
applicationVersion: jspb.Message.getFieldWithDefault(msg, 8, ""),
meshKey: msg.getMeshKey_asB64(),
clientPackageApiVersion: jspb.Message.getFieldWithDefault(msg, 10, 0),
identityType: jspb.Message.getFieldWithDefault(msg, 11, 0),
localId: jspb.Message.getFieldWithDefault(msg, 12, 0),
meshKeyHumanFriendlyName: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.RegistrationCommand}
 */
proto.RegistrationCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.RegistrationCommand;
  return proto.RegistrationCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.RegistrationCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.RegistrationCommand}
 */
proto.RegistrationCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setIdentityId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUserAccountId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTimestamp(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTimestampMillis(value);
      break;
    case 5:
      var value = new proto.UserProfile;
      reader.readMessage(value,proto.UserProfile.deserializeBinaryFromReader);
      msg.setProfile(value);
      break;
    case 6:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setApplicationClientId(value);
      break;
    case 7:
      var value = /** @type {!proto.RegistrationCommand.ApplicationType} */ (reader.readEnum());
      msg.setApplicationType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicationVersion(value);
      break;
    case 9:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMeshKey(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setClientPackageApiVersion(value);
      break;
    case 11:
      var value = /** @type {!proto.IdentityType} */ (reader.readEnum());
      msg.setIdentityType(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLocalId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setMeshKeyHumanFriendlyName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.RegistrationCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.RegistrationCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.RegistrationCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.RegistrationCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentityId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getUserAccountId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeFixed32(
      3,
      f
    );
  }
  f = message.getTimestampMillis();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getProfile();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.UserProfile.serializeBinaryToWriter
    );
  }
  f = message.getApplicationClientId_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      6,
      f
    );
  }
  f = message.getApplicationType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getApplicationVersion();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMeshKey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      9,
      f
    );
  }
  f = message.getClientPackageApiVersion();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getIdentityType();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getLocalId();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getMeshKeyHumanFriendlyName();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.RegistrationCommand.ApplicationType = {
  APPLICATIONTYPENONE: 0,
  APPLICATIONTYPEANDROID: 1,
  APPLICATIONTYPEIOS: 2,
  APPLICATIONTYPEATAK: 3
};

/**
 * optional uint64 identity_id = 1;
 * @return {number}
 */
proto.RegistrationCommand.prototype.getIdentityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.RegistrationCommand} returns this
 */
proto.RegistrationCommand.prototype.setIdentityId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 user_account_id = 2;
 * @return {number}
 */
proto.RegistrationCommand.prototype.getUserAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.RegistrationCommand} returns this
 */
proto.RegistrationCommand.prototype.setUserAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional fixed32 timestamp = 3;
 * @return {number}
 */
proto.RegistrationCommand.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.RegistrationCommand} returns this
 */
proto.RegistrationCommand.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 timestamp_millis = 4;
 * @return {number}
 */
proto.RegistrationCommand.prototype.getTimestampMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.RegistrationCommand} returns this
 */
proto.RegistrationCommand.prototype.setTimestampMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional UserProfile profile = 5;
 * @return {?proto.UserProfile}
 */
proto.RegistrationCommand.prototype.getProfile = function() {
  return /** @type{?proto.UserProfile} */ (
    jspb.Message.getWrapperField(this, proto.UserProfile, 5));
};


/**
 * @param {?proto.UserProfile|undefined} value
 * @return {!proto.RegistrationCommand} returns this
*/
proto.RegistrationCommand.prototype.setProfile = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.RegistrationCommand} returns this
 */
proto.RegistrationCommand.prototype.clearProfile = function() {
  return this.setProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.RegistrationCommand.prototype.hasProfile = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bytes application_client_id = 6;
 * @return {!(string|Uint8Array)}
 */
proto.RegistrationCommand.prototype.getApplicationClientId = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * optional bytes application_client_id = 6;
 * This is a type-conversion wrapper around `getApplicationClientId()`
 * @return {string}
 */
proto.RegistrationCommand.prototype.getApplicationClientId_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getApplicationClientId()));
};


/**
 * optional bytes application_client_id = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getApplicationClientId()`
 * @return {!Uint8Array}
 */
proto.RegistrationCommand.prototype.getApplicationClientId_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getApplicationClientId()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.RegistrationCommand} returns this
 */
proto.RegistrationCommand.prototype.setApplicationClientId = function(value) {
  return jspb.Message.setProto3BytesField(this, 6, value);
};


/**
 * optional ApplicationType application_type = 7;
 * @return {!proto.RegistrationCommand.ApplicationType}
 */
proto.RegistrationCommand.prototype.getApplicationType = function() {
  return /** @type {!proto.RegistrationCommand.ApplicationType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.RegistrationCommand.ApplicationType} value
 * @return {!proto.RegistrationCommand} returns this
 */
proto.RegistrationCommand.prototype.setApplicationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string application_version = 8;
 * @return {string}
 */
proto.RegistrationCommand.prototype.getApplicationVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.RegistrationCommand} returns this
 */
proto.RegistrationCommand.prototype.setApplicationVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bytes mesh_key = 9;
 * @return {!(string|Uint8Array)}
 */
proto.RegistrationCommand.prototype.getMeshKey = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * optional bytes mesh_key = 9;
 * This is a type-conversion wrapper around `getMeshKey()`
 * @return {string}
 */
proto.RegistrationCommand.prototype.getMeshKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMeshKey()));
};


/**
 * optional bytes mesh_key = 9;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMeshKey()`
 * @return {!Uint8Array}
 */
proto.RegistrationCommand.prototype.getMeshKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMeshKey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.RegistrationCommand} returns this
 */
proto.RegistrationCommand.prototype.setMeshKey = function(value) {
  return jspb.Message.setProto3BytesField(this, 9, value);
};


/**
 * optional uint32 client_package_api_version = 10;
 * @return {number}
 */
proto.RegistrationCommand.prototype.getClientPackageApiVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.RegistrationCommand} returns this
 */
proto.RegistrationCommand.prototype.setClientPackageApiVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional IdentityType identity_type = 11;
 * @return {!proto.IdentityType}
 */
proto.RegistrationCommand.prototype.getIdentityType = function() {
  return /** @type {!proto.IdentityType} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.IdentityType} value
 * @return {!proto.RegistrationCommand} returns this
 */
proto.RegistrationCommand.prototype.setIdentityType = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional uint32 local_id = 12;
 * @return {number}
 */
proto.RegistrationCommand.prototype.getLocalId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.RegistrationCommand} returns this
 */
proto.RegistrationCommand.prototype.setLocalId = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string mesh_key_human_friendly_name = 13;
 * @return {string}
 */
proto.RegistrationCommand.prototype.getMeshKeyHumanFriendlyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.RegistrationCommand} returns this
 */
proto.RegistrationCommand.prototype.setMeshKeyHumanFriendlyName = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UserProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.UserProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UserProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UserProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0),
defaultGpsInterval: jspb.Message.getFieldWithDefault(msg, 2, 0),
encryptionEnabled: jspb.Message.getFieldWithDefault(msg, 3, 0),
automaticTracking: jspb.Message.getFieldWithDefault(msg, 4, 0),
defaultSendInterval: jspb.Message.getFieldWithDefault(msg, 5, 0),
noSleep: jspb.Message.getFieldWithDefault(msg, 6, 0),
version: jspb.Message.getFieldWithDefault(msg, 7, 0),
batteryReporting: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UserProfile}
 */
proto.UserProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UserProfile;
  return proto.UserProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UserProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UserProfile}
 */
proto.UserProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.UserProfile.UserProfileType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDefaultGpsInterval(value);
      break;
    case 3:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setEncryptionEnabled(value);
      break;
    case 4:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setAutomaticTracking(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDefaultSendInterval(value);
      break;
    case 6:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setNoSleep(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersion(value);
      break;
    case 8:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setBatteryReporting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UserProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UserProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UserProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UserProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDefaultGpsInterval();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getEncryptionEnabled();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getAutomaticTracking();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getDefaultSendInterval();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getNoSleep();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getBatteryReporting();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.UserProfile.UserProfileType = {
  USERPROFILETYPENONE: 0,
  USERPROFILETYPECONSUMER: 1,
  USERPROFILETYPEENTERPRISE: 2,
  USERPROFILETYPESTEALTH: 3,
  USERPROFILETYPEATAKDEFAULT: 4
};

/**
 * optional UserProfileType type = 1;
 * @return {!proto.UserProfile.UserProfileType}
 */
proto.UserProfile.prototype.getType = function() {
  return /** @type {!proto.UserProfile.UserProfileType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.UserProfile.UserProfileType} value
 * @return {!proto.UserProfile} returns this
 */
proto.UserProfile.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional uint32 default_gps_interval = 2;
 * @return {number}
 */
proto.UserProfile.prototype.getDefaultGpsInterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.UserProfile} returns this
 */
proto.UserProfile.prototype.setDefaultGpsInterval = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional OptionalBool encryption_enabled = 3;
 * @return {!proto.OptionalBool}
 */
proto.UserProfile.prototype.getEncryptionEnabled = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.UserProfile} returns this
 */
proto.UserProfile.prototype.setEncryptionEnabled = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional OptionalBool automatic_tracking = 4;
 * @return {!proto.OptionalBool}
 */
proto.UserProfile.prototype.getAutomaticTracking = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.UserProfile} returns this
 */
proto.UserProfile.prototype.setAutomaticTracking = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional uint32 default_send_interval = 5;
 * @return {number}
 */
proto.UserProfile.prototype.getDefaultSendInterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.UserProfile} returns this
 */
proto.UserProfile.prototype.setDefaultSendInterval = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional OptionalBool no_sleep = 6;
 * @return {!proto.OptionalBool}
 */
proto.UserProfile.prototype.getNoSleep = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.UserProfile} returns this
 */
proto.UserProfile.prototype.setNoSleep = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional uint32 version = 7;
 * @return {number}
 */
proto.UserProfile.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.UserProfile} returns this
 */
proto.UserProfile.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional OptionalBool battery_reporting = 8;
 * @return {!proto.OptionalBool}
 */
proto.UserProfile.prototype.getBatteryReporting = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.UserProfile} returns this
 */
proto.UserProfile.prototype.setBatteryReporting = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.AltitudeRequestCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.AltitudeRequestCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.AltitudeRequestCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AltitudeRequestCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
timestamp: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AltitudeRequestCommand}
 */
proto.AltitudeRequestCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AltitudeRequestCommand;
  return proto.AltitudeRequestCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AltitudeRequestCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AltitudeRequestCommand}
 */
proto.AltitudeRequestCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AltitudeRequestCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.AltitudeRequestCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AltitudeRequestCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AltitudeRequestCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeFixed32(
      1,
      f
    );
  }
};


/**
 * optional fixed32 timestamp = 1;
 * @return {number}
 */
proto.AltitudeRequestCommand.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.AltitudeRequestCommand} returns this
 */
proto.AltitudeRequestCommand.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.AltitudeUpdateCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.AltitudeUpdateCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.AltitudeUpdateCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AltitudeUpdateCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
timestamp: jspb.Message.getFieldWithDefault(msg, 1, 0),
altitude: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AltitudeUpdateCommand}
 */
proto.AltitudeUpdateCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AltitudeUpdateCommand;
  return proto.AltitudeUpdateCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AltitudeUpdateCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AltitudeUpdateCommand}
 */
proto.AltitudeUpdateCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTimestamp(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setAltitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AltitudeUpdateCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.AltitudeUpdateCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AltitudeUpdateCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AltitudeUpdateCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeFixed32(
      1,
      f
    );
  }
  f = message.getAltitude();
  if (f !== 0) {
    writer.writeSint32(
      2,
      f
    );
  }
};


/**
 * optional fixed32 timestamp = 1;
 * @return {number}
 */
proto.AltitudeUpdateCommand.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.AltitudeUpdateCommand} returns this
 */
proto.AltitudeUpdateCommand.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional sint32 altitude = 2;
 * @return {number}
 */
proto.AltitudeUpdateCommand.prototype.getAltitude = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.AltitudeUpdateCommand} returns this
 */
proto.AltitudeUpdateCommand.prototype.setAltitude = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SerialNumberRequestCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.SerialNumberRequestCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SerialNumberRequestCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SerialNumberRequestCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
imei: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SerialNumberRequestCommand}
 */
proto.SerialNumberRequestCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SerialNumberRequestCommand;
  return proto.SerialNumberRequestCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SerialNumberRequestCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SerialNumberRequestCommand}
 */
proto.SerialNumberRequestCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImei(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SerialNumberRequestCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SerialNumberRequestCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SerialNumberRequestCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SerialNumberRequestCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImei();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string imei = 1;
 * @return {string}
 */
proto.SerialNumberRequestCommand.prototype.getImei = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SerialNumberRequestCommand} returns this
 */
proto.SerialNumberRequestCommand.prototype.setImei = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SerialNumberCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.SerialNumberCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SerialNumberCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SerialNumberCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
serial: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SerialNumberCommand}
 */
proto.SerialNumberCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SerialNumberCommand;
  return proto.SerialNumberCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SerialNumberCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SerialNumberCommand}
 */
proto.SerialNumberCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SerialNumberCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SerialNumberCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SerialNumberCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SerialNumberCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string serial = 1;
 * @return {string}
 */
proto.SerialNumberCommand.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SerialNumberCommand} returns this
 */
proto.SerialNumberCommand.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PeripheralCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.PeripheralCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PeripheralCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PeripheralCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
address: jspb.Message.getFieldWithDefault(msg, 1, ""),
connectionState: jspb.Message.getFieldWithDefault(msg, 2, 0),
errorCode: jspb.Message.getFieldWithDefault(msg, 3, 0),
type: jspb.Message.getFieldWithDefault(msg, 4, 0),
name: jspb.Message.getFieldWithDefault(msg, 5, ""),
id: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PeripheralCommand}
 */
proto.PeripheralCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PeripheralCommand;
  return proto.PeripheralCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PeripheralCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PeripheralCommand}
 */
proto.PeripheralCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 2:
      var value = /** @type {!proto.PeripheralCommand.ConnectionState} */ (reader.readEnum());
      msg.setConnectionState(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setErrorCode(value);
      break;
    case 4:
      var value = /** @type {!proto.PeripheralCommand.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PeripheralCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PeripheralCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PeripheralCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PeripheralCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConnectionState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getErrorCode();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.PeripheralCommand.Type = {
  UNKNOWN: 0,
  ZEPHYR: 1,
  WHOOP: 2,
  POLAR: 3
};

/**
 * @enum {number}
 */
proto.PeripheralCommand.ConnectionState = {
  DISCONNECTED: 0,
  CONNECTED: 1,
  CONNECTING: 2,
  DISCONNECTING: 3
};

/**
 * optional string address = 1;
 * @return {string}
 */
proto.PeripheralCommand.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PeripheralCommand} returns this
 */
proto.PeripheralCommand.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ConnectionState connection_state = 2;
 * @return {!proto.PeripheralCommand.ConnectionState}
 */
proto.PeripheralCommand.prototype.getConnectionState = function() {
  return /** @type {!proto.PeripheralCommand.ConnectionState} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.PeripheralCommand.ConnectionState} value
 * @return {!proto.PeripheralCommand} returns this
 */
proto.PeripheralCommand.prototype.setConnectionState = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional uint32 error_code = 3;
 * @return {number}
 */
proto.PeripheralCommand.prototype.getErrorCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.PeripheralCommand} returns this
 */
proto.PeripheralCommand.prototype.setErrorCode = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Type type = 4;
 * @return {!proto.PeripheralCommand.Type}
 */
proto.PeripheralCommand.prototype.getType = function() {
  return /** @type {!proto.PeripheralCommand.Type} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.PeripheralCommand.Type} value
 * @return {!proto.PeripheralCommand} returns this
 */
proto.PeripheralCommand.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.PeripheralCommand.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.PeripheralCommand} returns this
 */
proto.PeripheralCommand.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint64 id = 6;
 * @return {number}
 */
proto.PeripheralCommand.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.PeripheralCommand} returns this
 */
proto.PeripheralCommand.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.EligibleBackhaul.prototype.toObject = function(opt_includeInstance) {
  return proto.EligibleBackhaul.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EligibleBackhaul} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.EligibleBackhaul.toObject = function(includeInstance, msg) {
  var f, obj = {
isEligibleBackhaul: jspb.Message.getFieldWithDefault(msg, 1, 0),
expiresSeconds: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EligibleBackhaul}
 */
proto.EligibleBackhaul.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.EligibleBackhaul;
  return proto.EligibleBackhaul.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EligibleBackhaul} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EligibleBackhaul}
 */
proto.EligibleBackhaul.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setIsEligibleBackhaul(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExpiresSeconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.EligibleBackhaul.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.EligibleBackhaul.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EligibleBackhaul} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.EligibleBackhaul.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsEligibleBackhaul();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getExpiresSeconds();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional OptionalBool is_eligible_backhaul = 1;
 * @return {!proto.OptionalBool}
 */
proto.EligibleBackhaul.prototype.getIsEligibleBackhaul = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.EligibleBackhaul} returns this
 */
proto.EligibleBackhaul.prototype.setIsEligibleBackhaul = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional uint32 expires_seconds = 2;
 * @return {number}
 */
proto.EligibleBackhaul.prototype.getExpiresSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.EligibleBackhaul} returns this
 */
proto.EligibleBackhaul.prototype.setExpiresSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MeshNetworkUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.MeshNetworkUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MeshNetworkUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshNetworkUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
destination: jspb.Message.getFieldWithDefault(msg, 1, 0),
nextHop: jspb.Message.getFieldWithDefault(msg, 2, 0),
distance: jspb.Message.getFieldWithDefault(msg, 3, 0),
averageRssi: jspb.Message.getFieldWithDefault(msg, 4, 0),
timestamp: jspb.Message.getFieldWithDefault(msg, 5, 0),
eligibleBackhaul: (f = msg.getEligibleBackhaul()) && proto.EligibleBackhaul.toObject(includeInstance, f),
backhaulScore: jspb.Message.getFieldWithDefault(msg, 7, 0),
nextHopLocalId: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MeshNetworkUpdate}
 */
proto.MeshNetworkUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MeshNetworkUpdate;
  return proto.MeshNetworkUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MeshNetworkUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MeshNetworkUpdate}
 */
proto.MeshNetworkUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDestination(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNextHop(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDistance(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAverageRssi(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTimestamp(value);
      break;
    case 6:
      var value = new proto.EligibleBackhaul;
      reader.readMessage(value,proto.EligibleBackhaul.deserializeBinaryFromReader);
      msg.setEligibleBackhaul(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBackhaulScore(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNextHopLocalId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MeshNetworkUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MeshNetworkUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MeshNetworkUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshNetworkUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDestination();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getNextHop();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getDistance();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getAverageRssi();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeFixed32(
      5,
      f
    );
  }
  f = message.getEligibleBackhaul();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.EligibleBackhaul.serializeBinaryToWriter
    );
  }
  f = message.getBackhaulScore();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getNextHopLocalId();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
};


/**
 * optional uint32 destination = 1;
 * @return {number}
 */
proto.MeshNetworkUpdate.prototype.getDestination = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshNetworkUpdate} returns this
 */
proto.MeshNetworkUpdate.prototype.setDestination = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 next_hop = 2;
 * @return {number}
 */
proto.MeshNetworkUpdate.prototype.getNextHop = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshNetworkUpdate} returns this
 */
proto.MeshNetworkUpdate.prototype.setNextHop = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 distance = 3;
 * @return {number}
 */
proto.MeshNetworkUpdate.prototype.getDistance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshNetworkUpdate} returns this
 */
proto.MeshNetworkUpdate.prototype.setDistance = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 average_rssi = 4;
 * @return {number}
 */
proto.MeshNetworkUpdate.prototype.getAverageRssi = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshNetworkUpdate} returns this
 */
proto.MeshNetworkUpdate.prototype.setAverageRssi = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional fixed32 timestamp = 5;
 * @return {number}
 */
proto.MeshNetworkUpdate.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshNetworkUpdate} returns this
 */
proto.MeshNetworkUpdate.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional EligibleBackhaul eligible_backhaul = 6;
 * @return {?proto.EligibleBackhaul}
 */
proto.MeshNetworkUpdate.prototype.getEligibleBackhaul = function() {
  return /** @type{?proto.EligibleBackhaul} */ (
    jspb.Message.getWrapperField(this, proto.EligibleBackhaul, 6));
};


/**
 * @param {?proto.EligibleBackhaul|undefined} value
 * @return {!proto.MeshNetworkUpdate} returns this
*/
proto.MeshNetworkUpdate.prototype.setEligibleBackhaul = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.MeshNetworkUpdate} returns this
 */
proto.MeshNetworkUpdate.prototype.clearEligibleBackhaul = function() {
  return this.setEligibleBackhaul(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.MeshNetworkUpdate.prototype.hasEligibleBackhaul = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional uint32 backhaul_score = 7;
 * @return {number}
 */
proto.MeshNetworkUpdate.prototype.getBackhaulScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshNetworkUpdate} returns this
 */
proto.MeshNetworkUpdate.prototype.setBackhaulScore = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 next_hop_local_id = 8;
 * @return {number}
 */
proto.MeshNetworkUpdate.prototype.getNextHopLocalId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshNetworkUpdate} returns this
 */
proto.MeshNetworkUpdate.prototype.setNextHopLocalId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MeshNeighborUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.MeshNeighborUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MeshNeighborUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshNeighborUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
neighborLocalId: jspb.Message.getFieldWithDefault(msg, 1, 0),
timestamp: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MeshNeighborUpdate}
 */
proto.MeshNeighborUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MeshNeighborUpdate;
  return proto.MeshNeighborUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MeshNeighborUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MeshNeighborUpdate}
 */
proto.MeshNeighborUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNeighborLocalId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MeshNeighborUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MeshNeighborUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MeshNeighborUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshNeighborUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNeighborLocalId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeFixed32(
      2,
      f
    );
  }
};


/**
 * optional uint32 neighbor_local_id = 1;
 * @return {number}
 */
proto.MeshNeighborUpdate.prototype.getNeighborLocalId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshNeighborUpdate} returns this
 */
proto.MeshNeighborUpdate.prototype.setNeighborLocalId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional fixed32 timestamp = 2;
 * @return {number}
 */
proto.MeshNeighborUpdate.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshNeighborUpdate} returns this
 */
proto.MeshNeighborUpdate.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CellularStatusCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.CellularStatusCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CellularStatusCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CellularStatusCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
modemStatus: jspb.Message.getFieldWithDefault(msg, 1, 0),
networkStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
serverStatus: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CellularStatusCommand}
 */
proto.CellularStatusCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CellularStatusCommand;
  return proto.CellularStatusCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CellularStatusCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CellularStatusCommand}
 */
proto.CellularStatusCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.CellularStatusCommand.ConnectionStatus} */ (reader.readEnum());
      msg.setModemStatus(value);
      break;
    case 2:
      var value = /** @type {!proto.CellularStatusCommand.ConnectionStatus} */ (reader.readEnum());
      msg.setNetworkStatus(value);
      break;
    case 3:
      var value = /** @type {!proto.CellularStatusCommand.ConnectionStatus} */ (reader.readEnum());
      msg.setServerStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CellularStatusCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CellularStatusCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CellularStatusCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CellularStatusCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModemStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getNetworkStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getServerStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.CellularStatusCommand.ConnectionStatus = {
  DISCONNECTED: 0,
  CONNECTING: 1,
  CONNECTED: 2
};

/**
 * optional ConnectionStatus modem_status = 1;
 * @return {!proto.CellularStatusCommand.ConnectionStatus}
 */
proto.CellularStatusCommand.prototype.getModemStatus = function() {
  return /** @type {!proto.CellularStatusCommand.ConnectionStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.CellularStatusCommand.ConnectionStatus} value
 * @return {!proto.CellularStatusCommand} returns this
 */
proto.CellularStatusCommand.prototype.setModemStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional ConnectionStatus network_status = 2;
 * @return {!proto.CellularStatusCommand.ConnectionStatus}
 */
proto.CellularStatusCommand.prototype.getNetworkStatus = function() {
  return /** @type {!proto.CellularStatusCommand.ConnectionStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.CellularStatusCommand.ConnectionStatus} value
 * @return {!proto.CellularStatusCommand} returns this
 */
proto.CellularStatusCommand.prototype.setNetworkStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ConnectionStatus server_status = 3;
 * @return {!proto.CellularStatusCommand.ConnectionStatus}
 */
proto.CellularStatusCommand.prototype.getServerStatus = function() {
  return /** @type {!proto.CellularStatusCommand.ConnectionStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.CellularStatusCommand.ConnectionStatus} value
 * @return {!proto.CellularStatusCommand} returns this
 */
proto.CellularStatusCommand.prototype.setServerStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DataChunkCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.DataChunkCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DataChunkCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DataChunkCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
data: msg.getData_asB64(),
type: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DataChunkCommand}
 */
proto.DataChunkCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DataChunkCommand;
  return proto.DataChunkCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DataChunkCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DataChunkCommand}
 */
proto.DataChunkCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    case 2:
      var value = /** @type {!proto.DataChunkCommand.DataChunkType} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DataChunkCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DataChunkCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DataChunkCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DataChunkCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.DataChunkCommand.DataChunkType = {
  UNKNOWN: 0,
  MEMFAULT: 1
};

/**
 * optional bytes data = 1;
 * @return {!(string|Uint8Array)}
 */
proto.DataChunkCommand.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes data = 1;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.DataChunkCommand.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.DataChunkCommand.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.DataChunkCommand} returns this
 */
proto.DataChunkCommand.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional DataChunkType type = 2;
 * @return {!proto.DataChunkCommand.DataChunkType}
 */
proto.DataChunkCommand.prototype.getType = function() {
  return /** @type {!proto.DataChunkCommand.DataChunkType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.DataChunkCommand.DataChunkType} value
 * @return {!proto.DataChunkCommand} returns this
 */
proto.DataChunkCommand.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.FlashLogFileCommand.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.FlashLogFileCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.FlashLogFileCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.FlashLogFileCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FlashLogFileCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0),
fileNameNumsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
fileKey: msg.getFileKey_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FlashLogFileCommand}
 */
proto.FlashLogFileCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.FlashLogFileCommand;
  return proto.FlashLogFileCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FlashLogFileCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FlashLogFileCommand}
 */
proto.FlashLogFileCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.FlashLogFileCommand.FlashLogFileCommandType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addFileNameNums(values[i]);
      }
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFileKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.FlashLogFileCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.FlashLogFileCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FlashLogFileCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FlashLogFileCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getFileNameNumsList();
  if (f.length > 0) {
    writer.writePackedUint32(
      2,
      f
    );
  }
  f = message.getFileKey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.FlashLogFileCommand.FlashLogFileCommandType = {
  FLASHLOGFILECOMMANDNONE: 0,
  FLASHLOGFILECOMMANDFILELISTREQUEST: 1,
  FLASHLOGFILECOMMANDFILELISTAVAILABLE: 2,
  FLASHLOGFILECOMMANDFILEREADDONE: 3
};

/**
 * optional FlashLogFileCommandType type = 1;
 * @return {!proto.FlashLogFileCommand.FlashLogFileCommandType}
 */
proto.FlashLogFileCommand.prototype.getType = function() {
  return /** @type {!proto.FlashLogFileCommand.FlashLogFileCommandType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.FlashLogFileCommand.FlashLogFileCommandType} value
 * @return {!proto.FlashLogFileCommand} returns this
 */
proto.FlashLogFileCommand.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated uint32 file_name_nums = 2;
 * @return {!Array<number>}
 */
proto.FlashLogFileCommand.prototype.getFileNameNumsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.FlashLogFileCommand} returns this
 */
proto.FlashLogFileCommand.prototype.setFileNameNumsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.FlashLogFileCommand} returns this
 */
proto.FlashLogFileCommand.prototype.addFileNameNums = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.FlashLogFileCommand} returns this
 */
proto.FlashLogFileCommand.prototype.clearFileNameNumsList = function() {
  return this.setFileNameNumsList([]);
};


/**
 * optional bytes file_key = 3;
 * @return {!(string|Uint8Array)}
 */
proto.FlashLogFileCommand.prototype.getFileKey = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes file_key = 3;
 * This is a type-conversion wrapper around `getFileKey()`
 * @return {string}
 */
proto.FlashLogFileCommand.prototype.getFileKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFileKey()));
};


/**
 * optional bytes file_key = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFileKey()`
 * @return {!Uint8Array}
 */
proto.FlashLogFileCommand.prototype.getFileKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFileKey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.FlashLogFileCommand} returns this
 */
proto.FlashLogFileCommand.prototype.setFileKey = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MeshFileInitRequestCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.MeshFileInitRequestCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MeshFileInitRequestCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshFileInitRequestCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, 0),
fileMetadata: (f = msg.getFileMetadata()) && meshfile_proto_pb.MeshFileMetadata.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MeshFileInitRequestCommand}
 */
proto.MeshFileInitRequestCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MeshFileInitRequestCommand;
  return proto.MeshFileInitRequestCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MeshFileInitRequestCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MeshFileInitRequestCommand}
 */
proto.MeshFileInitRequestCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFileId(value);
      break;
    case 2:
      var value = new meshfile_proto_pb.MeshFileMetadata;
      reader.readMessage(value,meshfile_proto_pb.MeshFileMetadata.deserializeBinaryFromReader);
      msg.setFileMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MeshFileInitRequestCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MeshFileInitRequestCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MeshFileInitRequestCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshFileInitRequestCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getFileMetadata();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      meshfile_proto_pb.MeshFileMetadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 file_id = 1;
 * @return {number}
 */
proto.MeshFileInitRequestCommand.prototype.getFileId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshFileInitRequestCommand} returns this
 */
proto.MeshFileInitRequestCommand.prototype.setFileId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional MeshFileMetadata file_metadata = 2;
 * @return {?proto.MeshFileMetadata}
 */
proto.MeshFileInitRequestCommand.prototype.getFileMetadata = function() {
  return /** @type{?proto.MeshFileMetadata} */ (
    jspb.Message.getWrapperField(this, meshfile_proto_pb.MeshFileMetadata, 2));
};


/**
 * @param {?proto.MeshFileMetadata|undefined} value
 * @return {!proto.MeshFileInitRequestCommand} returns this
*/
proto.MeshFileInitRequestCommand.prototype.setFileMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.MeshFileInitRequestCommand} returns this
 */
proto.MeshFileInitRequestCommand.prototype.clearFileMetadata = function() {
  return this.setFileMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.MeshFileInitRequestCommand.prototype.hasFileMetadata = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.MeshFileInitResponseCommand.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MeshFileInitResponseCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.MeshFileInitResponseCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MeshFileInitResponseCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshFileInitResponseCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, 0),
declined: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
declineReason: jspb.Message.getFieldWithDefault(msg, 3, 0),
blockSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
participatedMeshNodesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MeshFileInitResponseCommand}
 */
proto.MeshFileInitResponseCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MeshFileInitResponseCommand;
  return proto.MeshFileInitResponseCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MeshFileInitResponseCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MeshFileInitResponseCommand}
 */
proto.MeshFileInitResponseCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFileId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeclined(value);
      break;
    case 3:
      var value = /** @type {!proto.MeshFile.DeclinedReason} */ (reader.readEnum());
      msg.setDeclineReason(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBlockSize(value);
      break;
    case 5:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint64() : [reader.readUint64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addParticipatedMeshNodes(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MeshFileInitResponseCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MeshFileInitResponseCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MeshFileInitResponseCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshFileInitResponseCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getDeclined();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDeclineReason();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getBlockSize();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getParticipatedMeshNodesList();
  if (f.length > 0) {
    writer.writePackedUint64(
      5,
      f
    );
  }
};


/**
 * optional uint64 file_id = 1;
 * @return {number}
 */
proto.MeshFileInitResponseCommand.prototype.getFileId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshFileInitResponseCommand} returns this
 */
proto.MeshFileInitResponseCommand.prototype.setFileId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool declined = 2;
 * @return {boolean}
 */
proto.MeshFileInitResponseCommand.prototype.getDeclined = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.MeshFileInitResponseCommand} returns this
 */
proto.MeshFileInitResponseCommand.prototype.setDeclined = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional MeshFile.DeclinedReason decline_reason = 3;
 * @return {!proto.MeshFile.DeclinedReason}
 */
proto.MeshFileInitResponseCommand.prototype.getDeclineReason = function() {
  return /** @type {!proto.MeshFile.DeclinedReason} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.MeshFile.DeclinedReason} value
 * @return {!proto.MeshFileInitResponseCommand} returns this
 */
proto.MeshFileInitResponseCommand.prototype.setDeclineReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional uint32 block_size = 4;
 * @return {number}
 */
proto.MeshFileInitResponseCommand.prototype.getBlockSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshFileInitResponseCommand} returns this
 */
proto.MeshFileInitResponseCommand.prototype.setBlockSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated uint64 participated_mesh_nodes = 5;
 * @return {!Array<number>}
 */
proto.MeshFileInitResponseCommand.prototype.getParticipatedMeshNodesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.MeshFileInitResponseCommand} returns this
 */
proto.MeshFileInitResponseCommand.prototype.setParticipatedMeshNodesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.MeshFileInitResponseCommand} returns this
 */
proto.MeshFileInitResponseCommand.prototype.addParticipatedMeshNodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.MeshFileInitResponseCommand} returns this
 */
proto.MeshFileInitResponseCommand.prototype.clearParticipatedMeshNodesList = function() {
  return this.setParticipatedMeshNodesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MeshFileBlockPartCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.MeshFileBlockPartCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MeshFileBlockPartCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshFileBlockPartCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, 0),
blockId: jspb.Message.getFieldWithDefault(msg, 2, 0),
partOffset: jspb.Message.getFieldWithDefault(msg, 3, 0),
partData: msg.getPartData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MeshFileBlockPartCommand}
 */
proto.MeshFileBlockPartCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MeshFileBlockPartCommand;
  return proto.MeshFileBlockPartCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MeshFileBlockPartCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MeshFileBlockPartCommand}
 */
proto.MeshFileBlockPartCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFileId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBlockId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPartOffset(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPartData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MeshFileBlockPartCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MeshFileBlockPartCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MeshFileBlockPartCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshFileBlockPartCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getBlockId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getPartOffset();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getPartData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
};


/**
 * optional uint64 file_id = 1;
 * @return {number}
 */
proto.MeshFileBlockPartCommand.prototype.getFileId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshFileBlockPartCommand} returns this
 */
proto.MeshFileBlockPartCommand.prototype.setFileId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 block_id = 2;
 * @return {number}
 */
proto.MeshFileBlockPartCommand.prototype.getBlockId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshFileBlockPartCommand} returns this
 */
proto.MeshFileBlockPartCommand.prototype.setBlockId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 part_offset = 3;
 * @return {number}
 */
proto.MeshFileBlockPartCommand.prototype.getPartOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshFileBlockPartCommand} returns this
 */
proto.MeshFileBlockPartCommand.prototype.setPartOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bytes part_data = 4;
 * @return {!(string|Uint8Array)}
 */
proto.MeshFileBlockPartCommand.prototype.getPartData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes part_data = 4;
 * This is a type-conversion wrapper around `getPartData()`
 * @return {string}
 */
proto.MeshFileBlockPartCommand.prototype.getPartData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPartData()));
};


/**
 * optional bytes part_data = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPartData()`
 * @return {!Uint8Array}
 */
proto.MeshFileBlockPartCommand.prototype.getPartData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPartData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.MeshFileBlockPartCommand} returns this
 */
proto.MeshFileBlockPartCommand.prototype.setPartData = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.MeshFileBlockTxDoneCommand.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MeshFileBlockTxDoneCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.MeshFileBlockTxDoneCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MeshFileBlockTxDoneCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshFileBlockTxDoneCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, 0),
blockId: jspb.Message.getFieldWithDefault(msg, 2, 0),
successMeshNodesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MeshFileBlockTxDoneCommand}
 */
proto.MeshFileBlockTxDoneCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MeshFileBlockTxDoneCommand;
  return proto.MeshFileBlockTxDoneCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MeshFileBlockTxDoneCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MeshFileBlockTxDoneCommand}
 */
proto.MeshFileBlockTxDoneCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFileId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBlockId(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint64() : [reader.readUint64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSuccessMeshNodes(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MeshFileBlockTxDoneCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MeshFileBlockTxDoneCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MeshFileBlockTxDoneCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshFileBlockTxDoneCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getBlockId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getSuccessMeshNodesList();
  if (f.length > 0) {
    writer.writePackedUint64(
      3,
      f
    );
  }
};


/**
 * optional uint64 file_id = 1;
 * @return {number}
 */
proto.MeshFileBlockTxDoneCommand.prototype.getFileId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshFileBlockTxDoneCommand} returns this
 */
proto.MeshFileBlockTxDoneCommand.prototype.setFileId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 block_id = 2;
 * @return {number}
 */
proto.MeshFileBlockTxDoneCommand.prototype.getBlockId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshFileBlockTxDoneCommand} returns this
 */
proto.MeshFileBlockTxDoneCommand.prototype.setBlockId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated uint64 success_mesh_nodes = 3;
 * @return {!Array<number>}
 */
proto.MeshFileBlockTxDoneCommand.prototype.getSuccessMeshNodesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.MeshFileBlockTxDoneCommand} returns this
 */
proto.MeshFileBlockTxDoneCommand.prototype.setSuccessMeshNodesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.MeshFileBlockTxDoneCommand} returns this
 */
proto.MeshFileBlockTxDoneCommand.prototype.addSuccessMeshNodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.MeshFileBlockTxDoneCommand} returns this
 */
proto.MeshFileBlockTxDoneCommand.prototype.clearSuccessMeshNodesList = function() {
  return this.setSuccessMeshNodesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MeshFileInitiatedCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.MeshFileInitiatedCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MeshFileInitiatedCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshFileInitiatedCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, 0),
fileMetadata: (f = msg.getFileMetadata()) && meshfile_proto_pb.MeshFileMetadata.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MeshFileInitiatedCommand}
 */
proto.MeshFileInitiatedCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MeshFileInitiatedCommand;
  return proto.MeshFileInitiatedCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MeshFileInitiatedCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MeshFileInitiatedCommand}
 */
proto.MeshFileInitiatedCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFileId(value);
      break;
    case 2:
      var value = new meshfile_proto_pb.MeshFileMetadata;
      reader.readMessage(value,meshfile_proto_pb.MeshFileMetadata.deserializeBinaryFromReader);
      msg.setFileMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MeshFileInitiatedCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MeshFileInitiatedCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MeshFileInitiatedCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshFileInitiatedCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getFileMetadata();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      meshfile_proto_pb.MeshFileMetadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 file_id = 1;
 * @return {number}
 */
proto.MeshFileInitiatedCommand.prototype.getFileId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshFileInitiatedCommand} returns this
 */
proto.MeshFileInitiatedCommand.prototype.setFileId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional MeshFileMetadata file_metadata = 2;
 * @return {?proto.MeshFileMetadata}
 */
proto.MeshFileInitiatedCommand.prototype.getFileMetadata = function() {
  return /** @type{?proto.MeshFileMetadata} */ (
    jspb.Message.getWrapperField(this, meshfile_proto_pb.MeshFileMetadata, 2));
};


/**
 * @param {?proto.MeshFileMetadata|undefined} value
 * @return {!proto.MeshFileInitiatedCommand} returns this
*/
proto.MeshFileInitiatedCommand.prototype.setFileMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.MeshFileInitiatedCommand} returns this
 */
proto.MeshFileInitiatedCommand.prototype.clearFileMetadata = function() {
  return this.setFileMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.MeshFileInitiatedCommand.prototype.hasFileMetadata = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MeshFileInitiatedAckCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.MeshFileInitiatedAckCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MeshFileInitiatedAckCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshFileInitiatedAckCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
fileId: jspb.Message.getFieldWithDefault(msg, 1, 0),
decline: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
reason: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MeshFileInitiatedAckCommand}
 */
proto.MeshFileInitiatedAckCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MeshFileInitiatedAckCommand;
  return proto.MeshFileInitiatedAckCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MeshFileInitiatedAckCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MeshFileInitiatedAckCommand}
 */
proto.MeshFileInitiatedAckCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFileId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDecline(value);
      break;
    case 3:
      var value = /** @type {!proto.MeshFile.DeclinedReason} */ (reader.readEnum());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MeshFileInitiatedAckCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MeshFileInitiatedAckCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MeshFileInitiatedAckCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshFileInitiatedAckCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getDecline();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getReason();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional uint64 file_id = 1;
 * @return {number}
 */
proto.MeshFileInitiatedAckCommand.prototype.getFileId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshFileInitiatedAckCommand} returns this
 */
proto.MeshFileInitiatedAckCommand.prototype.setFileId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool decline = 2;
 * @return {boolean}
 */
proto.MeshFileInitiatedAckCommand.prototype.getDecline = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.MeshFileInitiatedAckCommand} returns this
 */
proto.MeshFileInitiatedAckCommand.prototype.setDecline = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional MeshFile.DeclinedReason reason = 3;
 * @return {!proto.MeshFile.DeclinedReason}
 */
proto.MeshFileInitiatedAckCommand.prototype.getReason = function() {
  return /** @type {!proto.MeshFile.DeclinedReason} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.MeshFile.DeclinedReason} value
 * @return {!proto.MeshFileInitiatedAckCommand} returns this
 */
proto.MeshFileInitiatedAckCommand.prototype.setReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MeshCmdDataSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.MeshCmdDataSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MeshCmdDataSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshCmdDataSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
settingsCommand: (f = msg.getSettingsCommand()) && proto.SettingsCommand.toObject(includeInstance, f),
batteryCommand: (f = msg.getBatteryCommand()) && command_public_proto_pb.BatteryCommand.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MeshCmdDataSettings}
 */
proto.MeshCmdDataSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MeshCmdDataSettings;
  return proto.MeshCmdDataSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MeshCmdDataSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MeshCmdDataSettings}
 */
proto.MeshCmdDataSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.SettingsCommand;
      reader.readMessage(value,proto.SettingsCommand.deserializeBinaryFromReader);
      msg.setSettingsCommand(value);
      break;
    case 2:
      var value = new command_public_proto_pb.BatteryCommand;
      reader.readMessage(value,command_public_proto_pb.BatteryCommand.deserializeBinaryFromReader);
      msg.setBatteryCommand(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MeshCmdDataSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MeshCmdDataSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MeshCmdDataSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshCmdDataSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettingsCommand();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.SettingsCommand.serializeBinaryToWriter
    );
  }
  f = message.getBatteryCommand();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      command_public_proto_pb.BatteryCommand.serializeBinaryToWriter
    );
  }
};


/**
 * optional SettingsCommand settings_command = 1;
 * @return {?proto.SettingsCommand}
 */
proto.MeshCmdDataSettings.prototype.getSettingsCommand = function() {
  return /** @type{?proto.SettingsCommand} */ (
    jspb.Message.getWrapperField(this, proto.SettingsCommand, 1));
};


/**
 * @param {?proto.SettingsCommand|undefined} value
 * @return {!proto.MeshCmdDataSettings} returns this
*/
proto.MeshCmdDataSettings.prototype.setSettingsCommand = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.MeshCmdDataSettings} returns this
 */
proto.MeshCmdDataSettings.prototype.clearSettingsCommand = function() {
  return this.setSettingsCommand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.MeshCmdDataSettings.prototype.hasSettingsCommand = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional BatteryCommand battery_command = 2;
 * @return {?proto.BatteryCommand}
 */
proto.MeshCmdDataSettings.prototype.getBatteryCommand = function() {
  return /** @type{?proto.BatteryCommand} */ (
    jspb.Message.getWrapperField(this, command_public_proto_pb.BatteryCommand, 2));
};


/**
 * @param {?proto.BatteryCommand|undefined} value
 * @return {!proto.MeshCmdDataSettings} returns this
*/
proto.MeshCmdDataSettings.prototype.setBatteryCommand = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.MeshCmdDataSettings} returns this
 */
proto.MeshCmdDataSettings.prototype.clearBatteryCommand = function() {
  return this.setBatteryCommand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.MeshCmdDataSettings.prototype.hasBatteryCommand = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ShortMeshNetworkUpdateEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.ShortMeshNetworkUpdateEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ShortMeshNetworkUpdateEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ShortMeshNetworkUpdateEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
timestamp: jspb.Message.getFieldWithDefault(msg, 1, 0),
destination: jspb.Message.getFieldWithDefault(msg, 2, 0),
distance: jspb.Message.getFieldWithDefault(msg, 3, 0),
averageRssi: jspb.Message.getFieldWithDefault(msg, 4, 0),
backhaulScore: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ShortMeshNetworkUpdateEntry}
 */
proto.ShortMeshNetworkUpdateEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ShortMeshNetworkUpdateEntry;
  return proto.ShortMeshNetworkUpdateEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ShortMeshNetworkUpdateEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ShortMeshNetworkUpdateEntry}
 */
proto.ShortMeshNetworkUpdateEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTimestamp(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDestination(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDistance(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAverageRssi(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBackhaulScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ShortMeshNetworkUpdateEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ShortMeshNetworkUpdateEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ShortMeshNetworkUpdateEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ShortMeshNetworkUpdateEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeFixed32(
      1,
      f
    );
  }
  f = message.getDestination();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getDistance();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getAverageRssi();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getBackhaulScore();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional fixed32 timestamp = 1;
 * @return {number}
 */
proto.ShortMeshNetworkUpdateEntry.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ShortMeshNetworkUpdateEntry} returns this
 */
proto.ShortMeshNetworkUpdateEntry.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 destination = 2;
 * @return {number}
 */
proto.ShortMeshNetworkUpdateEntry.prototype.getDestination = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ShortMeshNetworkUpdateEntry} returns this
 */
proto.ShortMeshNetworkUpdateEntry.prototype.setDestination = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 distance = 3;
 * @return {number}
 */
proto.ShortMeshNetworkUpdateEntry.prototype.getDistance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ShortMeshNetworkUpdateEntry} returns this
 */
proto.ShortMeshNetworkUpdateEntry.prototype.setDistance = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 average_rssi = 4;
 * @return {number}
 */
proto.ShortMeshNetworkUpdateEntry.prototype.getAverageRssi = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ShortMeshNetworkUpdateEntry} returns this
 */
proto.ShortMeshNetworkUpdateEntry.prototype.setAverageRssi = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 backhaul_score = 5;
 * @return {number}
 */
proto.ShortMeshNetworkUpdateEntry.prototype.getBackhaulScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.ShortMeshNetworkUpdateEntry} returns this
 */
proto.ShortMeshNetworkUpdateEntry.prototype.setBackhaulScore = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.MeshCmdDataMeshNetworkUpdates.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MeshCmdDataMeshNetworkUpdates.prototype.toObject = function(opt_includeInstance) {
  return proto.MeshCmdDataMeshNetworkUpdates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MeshCmdDataMeshNetworkUpdates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshCmdDataMeshNetworkUpdates.toObject = function(includeInstance, msg) {
  var f, obj = {
isTruncated: jspb.Message.getFieldWithDefault(msg, 1, 0),
entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    proto.ShortMeshNetworkUpdateEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MeshCmdDataMeshNetworkUpdates}
 */
proto.MeshCmdDataMeshNetworkUpdates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MeshCmdDataMeshNetworkUpdates;
  return proto.MeshCmdDataMeshNetworkUpdates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MeshCmdDataMeshNetworkUpdates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MeshCmdDataMeshNetworkUpdates}
 */
proto.MeshCmdDataMeshNetworkUpdates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setIsTruncated(value);
      break;
    case 2:
      var value = new proto.ShortMeshNetworkUpdateEntry;
      reader.readMessage(value,proto.ShortMeshNetworkUpdateEntry.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MeshCmdDataMeshNetworkUpdates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MeshCmdDataMeshNetworkUpdates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MeshCmdDataMeshNetworkUpdates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshCmdDataMeshNetworkUpdates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsTruncated();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.ShortMeshNetworkUpdateEntry.serializeBinaryToWriter
    );
  }
};


/**
 * optional OptionalBool is_truncated = 1;
 * @return {!proto.OptionalBool}
 */
proto.MeshCmdDataMeshNetworkUpdates.prototype.getIsTruncated = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.MeshCmdDataMeshNetworkUpdates} returns this
 */
proto.MeshCmdDataMeshNetworkUpdates.prototype.setIsTruncated = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated ShortMeshNetworkUpdateEntry entries = 2;
 * @return {!Array<!proto.ShortMeshNetworkUpdateEntry>}
 */
proto.MeshCmdDataMeshNetworkUpdates.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.ShortMeshNetworkUpdateEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ShortMeshNetworkUpdateEntry, 2));
};


/**
 * @param {!Array<!proto.ShortMeshNetworkUpdateEntry>} value
 * @return {!proto.MeshCmdDataMeshNetworkUpdates} returns this
*/
proto.MeshCmdDataMeshNetworkUpdates.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.ShortMeshNetworkUpdateEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ShortMeshNetworkUpdateEntry}
 */
proto.MeshCmdDataMeshNetworkUpdates.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.ShortMeshNetworkUpdateEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.MeshCmdDataMeshNetworkUpdates} returns this
 */
proto.MeshCmdDataMeshNetworkUpdates.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MeshCmdGetCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.MeshCmdGetCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MeshCmdGetCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshCmdGetCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
peerUserAccountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
dataType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MeshCmdGetCommand}
 */
proto.MeshCmdGetCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MeshCmdGetCommand;
  return proto.MeshCmdGetCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MeshCmdGetCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MeshCmdGetCommand}
 */
proto.MeshCmdGetCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPeerUserAccountId(value);
      break;
    case 2:
      var value = /** @type {!proto.MeshCmdDataType} */ (reader.readEnum());
      msg.setDataType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MeshCmdGetCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MeshCmdGetCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MeshCmdGetCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshCmdGetCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPeerUserAccountId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getDataType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional uint64 peer_user_account_id = 1;
 * @return {number}
 */
proto.MeshCmdGetCommand.prototype.getPeerUserAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshCmdGetCommand} returns this
 */
proto.MeshCmdGetCommand.prototype.setPeerUserAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional MeshCmdDataType data_type = 2;
 * @return {!proto.MeshCmdDataType}
 */
proto.MeshCmdGetCommand.prototype.getDataType = function() {
  return /** @type {!proto.MeshCmdDataType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.MeshCmdDataType} value
 * @return {!proto.MeshCmdGetCommand} returns this
 */
proto.MeshCmdGetCommand.prototype.setDataType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MeshCmdSetCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.MeshCmdSetCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MeshCmdSetCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshCmdSetCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
peerUserAccountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
dataType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MeshCmdSetCommand}
 */
proto.MeshCmdSetCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MeshCmdSetCommand;
  return proto.MeshCmdSetCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MeshCmdSetCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MeshCmdSetCommand}
 */
proto.MeshCmdSetCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPeerUserAccountId(value);
      break;
    case 2:
      var value = /** @type {!proto.MeshCmdDataType} */ (reader.readEnum());
      msg.setDataType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MeshCmdSetCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MeshCmdSetCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MeshCmdSetCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshCmdSetCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPeerUserAccountId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getDataType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional uint64 peer_user_account_id = 1;
 * @return {number}
 */
proto.MeshCmdSetCommand.prototype.getPeerUserAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshCmdSetCommand} returns this
 */
proto.MeshCmdSetCommand.prototype.setPeerUserAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional MeshCmdDataType data_type = 2;
 * @return {!proto.MeshCmdDataType}
 */
proto.MeshCmdSetCommand.prototype.getDataType = function() {
  return /** @type {!proto.MeshCmdDataType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.MeshCmdDataType} value
 * @return {!proto.MeshCmdSetCommand} returns this
 */
proto.MeshCmdSetCommand.prototype.setDataType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.MeshCmdReportCommand.oneofGroups_ = [[5,6,7]];

/**
 * @enum {number}
 */
proto.MeshCmdReportCommand.DataCase = {
  DATA_NOT_SET: 0,
  EMPTY_DATA: 5,
  SETTINGS: 6,
  MESH_NETWORK_UPDATES: 7
};

/**
 * @return {proto.MeshCmdReportCommand.DataCase}
 */
proto.MeshCmdReportCommand.prototype.getDataCase = function() {
  return /** @type {proto.MeshCmdReportCommand.DataCase} */(jspb.Message.computeOneofCase(this, proto.MeshCmdReportCommand.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MeshCmdReportCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.MeshCmdReportCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MeshCmdReportCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshCmdReportCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
sourceUserAccountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
meshCmdTypeTriggeredReport: jspb.Message.getFieldWithDefault(msg, 2, 0),
dataType: jspb.Message.getFieldWithDefault(msg, 3, 0),
isSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
emptyData: (f = msg.getEmptyData()) && proto.MeshCmdReportCommand.EmptyData.toObject(includeInstance, f),
settings: (f = msg.getSettings()) && proto.MeshCmdDataSettings.toObject(includeInstance, f),
meshNetworkUpdates: (f = msg.getMeshNetworkUpdates()) && proto.MeshCmdDataMeshNetworkUpdates.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MeshCmdReportCommand}
 */
proto.MeshCmdReportCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MeshCmdReportCommand;
  return proto.MeshCmdReportCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MeshCmdReportCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MeshCmdReportCommand}
 */
proto.MeshCmdReportCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSourceUserAccountId(value);
      break;
    case 2:
      var value = /** @type {!proto.MeshCmdTypeTriggeredReport} */ (reader.readEnum());
      msg.setMeshCmdTypeTriggeredReport(value);
      break;
    case 3:
      var value = /** @type {!proto.MeshCmdDataType} */ (reader.readEnum());
      msg.setDataType(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuccess(value);
      break;
    case 5:
      var value = new proto.MeshCmdReportCommand.EmptyData;
      reader.readMessage(value,proto.MeshCmdReportCommand.EmptyData.deserializeBinaryFromReader);
      msg.setEmptyData(value);
      break;
    case 6:
      var value = new proto.MeshCmdDataSettings;
      reader.readMessage(value,proto.MeshCmdDataSettings.deserializeBinaryFromReader);
      msg.setSettings(value);
      break;
    case 7:
      var value = new proto.MeshCmdDataMeshNetworkUpdates;
      reader.readMessage(value,proto.MeshCmdDataMeshNetworkUpdates.deserializeBinaryFromReader);
      msg.setMeshNetworkUpdates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MeshCmdReportCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MeshCmdReportCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MeshCmdReportCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshCmdReportCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSourceUserAccountId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getMeshCmdTypeTriggeredReport();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDataType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getIsSuccess();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getEmptyData();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.MeshCmdReportCommand.EmptyData.serializeBinaryToWriter
    );
  }
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.MeshCmdDataSettings.serializeBinaryToWriter
    );
  }
  f = message.getMeshNetworkUpdates();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.MeshCmdDataMeshNetworkUpdates.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MeshCmdReportCommand.EmptyData.prototype.toObject = function(opt_includeInstance) {
  return proto.MeshCmdReportCommand.EmptyData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MeshCmdReportCommand.EmptyData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshCmdReportCommand.EmptyData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MeshCmdReportCommand.EmptyData}
 */
proto.MeshCmdReportCommand.EmptyData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MeshCmdReportCommand.EmptyData;
  return proto.MeshCmdReportCommand.EmptyData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MeshCmdReportCommand.EmptyData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MeshCmdReportCommand.EmptyData}
 */
proto.MeshCmdReportCommand.EmptyData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MeshCmdReportCommand.EmptyData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MeshCmdReportCommand.EmptyData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MeshCmdReportCommand.EmptyData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MeshCmdReportCommand.EmptyData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional uint64 source_user_account_id = 1;
 * @return {number}
 */
proto.MeshCmdReportCommand.prototype.getSourceUserAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.MeshCmdReportCommand} returns this
 */
proto.MeshCmdReportCommand.prototype.setSourceUserAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional MeshCmdTypeTriggeredReport mesh_cmd_type_triggered_report = 2;
 * @return {!proto.MeshCmdTypeTriggeredReport}
 */
proto.MeshCmdReportCommand.prototype.getMeshCmdTypeTriggeredReport = function() {
  return /** @type {!proto.MeshCmdTypeTriggeredReport} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.MeshCmdTypeTriggeredReport} value
 * @return {!proto.MeshCmdReportCommand} returns this
 */
proto.MeshCmdReportCommand.prototype.setMeshCmdTypeTriggeredReport = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional MeshCmdDataType data_type = 3;
 * @return {!proto.MeshCmdDataType}
 */
proto.MeshCmdReportCommand.prototype.getDataType = function() {
  return /** @type {!proto.MeshCmdDataType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.MeshCmdDataType} value
 * @return {!proto.MeshCmdReportCommand} returns this
 */
proto.MeshCmdReportCommand.prototype.setDataType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional bool is_success = 4;
 * @return {boolean}
 */
proto.MeshCmdReportCommand.prototype.getIsSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.MeshCmdReportCommand} returns this
 */
proto.MeshCmdReportCommand.prototype.setIsSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional EmptyData empty_data = 5;
 * @return {?proto.MeshCmdReportCommand.EmptyData}
 */
proto.MeshCmdReportCommand.prototype.getEmptyData = function() {
  return /** @type{?proto.MeshCmdReportCommand.EmptyData} */ (
    jspb.Message.getWrapperField(this, proto.MeshCmdReportCommand.EmptyData, 5));
};


/**
 * @param {?proto.MeshCmdReportCommand.EmptyData|undefined} value
 * @return {!proto.MeshCmdReportCommand} returns this
*/
proto.MeshCmdReportCommand.prototype.setEmptyData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.MeshCmdReportCommand.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.MeshCmdReportCommand} returns this
 */
proto.MeshCmdReportCommand.prototype.clearEmptyData = function() {
  return this.setEmptyData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.MeshCmdReportCommand.prototype.hasEmptyData = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional MeshCmdDataSettings settings = 6;
 * @return {?proto.MeshCmdDataSettings}
 */
proto.MeshCmdReportCommand.prototype.getSettings = function() {
  return /** @type{?proto.MeshCmdDataSettings} */ (
    jspb.Message.getWrapperField(this, proto.MeshCmdDataSettings, 6));
};


/**
 * @param {?proto.MeshCmdDataSettings|undefined} value
 * @return {!proto.MeshCmdReportCommand} returns this
*/
proto.MeshCmdReportCommand.prototype.setSettings = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.MeshCmdReportCommand.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.MeshCmdReportCommand} returns this
 */
proto.MeshCmdReportCommand.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.MeshCmdReportCommand.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional MeshCmdDataMeshNetworkUpdates mesh_network_updates = 7;
 * @return {?proto.MeshCmdDataMeshNetworkUpdates}
 */
proto.MeshCmdReportCommand.prototype.getMeshNetworkUpdates = function() {
  return /** @type{?proto.MeshCmdDataMeshNetworkUpdates} */ (
    jspb.Message.getWrapperField(this, proto.MeshCmdDataMeshNetworkUpdates, 7));
};


/**
 * @param {?proto.MeshCmdDataMeshNetworkUpdates|undefined} value
 * @return {!proto.MeshCmdReportCommand} returns this
*/
proto.MeshCmdReportCommand.prototype.setMeshNetworkUpdates = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.MeshCmdReportCommand.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.MeshCmdReportCommand} returns this
 */
proto.MeshCmdReportCommand.prototype.clearMeshNetworkUpdates = function() {
  return this.setMeshNetworkUpdates(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.MeshCmdReportCommand.prototype.hasMeshNetworkUpdates = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeviceForwardConfirmCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.DeviceForwardConfirmCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeviceForwardConfirmCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceForwardConfirmCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
packageId: jspb.Message.getFieldWithDefault(msg, 1, 0),
imei: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeviceForwardConfirmCommand}
 */
proto.DeviceForwardConfirmCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeviceForwardConfirmCommand;
  return proto.DeviceForwardConfirmCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeviceForwardConfirmCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeviceForwardConfirmCommand}
 */
proto.DeviceForwardConfirmCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPackageId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setImei(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeviceForwardConfirmCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeviceForwardConfirmCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeviceForwardConfirmCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeviceForwardConfirmCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackageId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getImei();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint64 package_id = 1;
 * @return {number}
 */
proto.DeviceForwardConfirmCommand.prototype.getPackageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.DeviceForwardConfirmCommand} returns this
 */
proto.DeviceForwardConfirmCommand.prototype.setPackageId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string imei = 2;
 * @return {string}
 */
proto.DeviceForwardConfirmCommand.prototype.getImei = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeviceForwardConfirmCommand} returns this
 */
proto.DeviceForwardConfirmCommand.prototype.setImei = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.FactoryCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.FactoryCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.FactoryCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FactoryCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
magic: jspb.Message.getFieldWithDefault(msg, 1, 0),
type: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FactoryCommand}
 */
proto.FactoryCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.FactoryCommand;
  return proto.FactoryCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FactoryCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FactoryCommand}
 */
proto.FactoryCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMagic(value);
      break;
    case 2:
      var value = /** @type {!proto.FactoryCommand.FactoryCommandType} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.FactoryCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.FactoryCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FactoryCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FactoryCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMagic();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.FactoryCommand.FactoryCommandType = {
  FACTORYCOMMANDNOP: 0,
  FACTORYCOMMANDIRIDIUMPASSTHROUGH: 1,
  FACTORYCOMMANDGPSPASSTHROUGH: 2
};

/**
 * optional uint32 magic = 1;
 * @return {number}
 */
proto.FactoryCommand.prototype.getMagic = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.FactoryCommand} returns this
 */
proto.FactoryCommand.prototype.setMagic = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional FactoryCommandType type = 2;
 * @return {!proto.FactoryCommand.FactoryCommandType}
 */
proto.FactoryCommand.prototype.getType = function() {
  return /** @type {!proto.FactoryCommand.FactoryCommandType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.FactoryCommand.FactoryCommandType} value
 * @return {!proto.FactoryCommand} returns this
 */
proto.FactoryCommand.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DevicePowerOnoffCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.DevicePowerOnoffCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DevicePowerOnoffCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DevicePowerOnoffCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DevicePowerOnoffCommand}
 */
proto.DevicePowerOnoffCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DevicePowerOnoffCommand;
  return proto.DevicePowerOnoffCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DevicePowerOnoffCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DevicePowerOnoffCommand}
 */
proto.DevicePowerOnoffCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.DevicePowerOnoffCommand.DevicePowerOnoffType} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DevicePowerOnoffCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DevicePowerOnoffCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DevicePowerOnoffCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DevicePowerOnoffCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.DevicePowerOnoffCommand.DevicePowerOnoffType = {
  DEVICEPOWERONOFFNONE: 0,
  DEVICEPOWERONOFFON: 1,
  DEVICEPOWERONOFFOFF: 2
};

/**
 * optional DevicePowerOnoffType type = 1;
 * @return {!proto.DevicePowerOnoffCommand.DevicePowerOnoffType}
 */
proto.DevicePowerOnoffCommand.prototype.getType = function() {
  return /** @type {!proto.DevicePowerOnoffCommand.DevicePowerOnoffType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.DevicePowerOnoffCommand.DevicePowerOnoffType} value
 * @return {!proto.DevicePowerOnoffCommand} returns this
 */
proto.DevicePowerOnoffCommand.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


goog.object.extend(exports, proto);
